export const Print = (
  <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.476562"
      y="0.664062"
      width="45.2365"
      height="38.1576"
      rx="5.30912"
      fill="#E8F0FF"
    />
    <path
      d="M29.0957 14.7422H17.0957V10.7422H29.0957V14.7422ZM29.0957 20.2422C29.379 20.2422 29.6167 20.1462 29.8087 19.9542C30.0007 19.7622 30.0964 19.5249 30.0957 19.2422C30.095 18.9595 29.999 18.7222 29.8077 18.5302C29.6164 18.3382 29.379 18.2422 29.0957 18.2422C28.8124 18.2422 28.575 18.3382 28.3837 18.5302C28.1924 18.7222 28.0964 18.9595 28.0957 19.2422C28.095 19.5249 28.191 19.7625 28.3837 19.9552C28.5764 20.1479 28.8137 20.2435 29.0957 20.2422ZM27.0957 26.7422V22.7422H19.0957V26.7422H27.0957ZM29.0957 28.7422H17.0957V24.7422H13.0957V18.7422C13.0957 17.8922 13.3874 17.1799 13.9707 16.6052C14.554 16.0305 15.2624 15.7429 16.0957 15.7422H30.0957C30.9457 15.7422 31.6584 16.0299 32.2337 16.6052C32.809 17.1805 33.0964 17.8929 33.0957 18.7422V24.7422H29.0957V28.7422Z"
      fill="#1155CC"
    />
  </svg>
);
